import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { createLink } from '@tanstack/react-router'
import React from 'react'
import styled from 'styled-components'

export const StyledDropdownMenuTrigger = styled(DropdownMenu.Trigger)`
  cursor: pointer;
`

export const StyledDropdownMenuContent = styled(DropdownMenu.Content)`
  z-index: 1000;
  width: 240px;
  padding: 0.5rem;
  color: ${({ theme }) => theme.forecast.defaultText};
  background-color: ${({ theme }) => theme.forecast.background2};
  border-radius: 0.5rem;
  box-shadow:
    0 0.625rem 2.375rem -0.625rem rgba(22, 23, 24, 0.35),
    0 0.625rem 1.25rem -0.9375rem rgba(22, 23, 24, 0.2);
`

const StyledAnchor = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.forecast.secondaryText};

  &:hover {
    color: ${({ theme }) => theme.forecast.activeText};
  }
`

type DropdownAnchorProps = React.ComponentPropsWithoutRef<'a'>

const DropdownAnchor = React.forwardRef<HTMLAnchorElement, DropdownAnchorProps>(
  function DropdownAnchor({ children, ...props }, ref) {
    return (
      <DropdownMenu.Item asChild>
        <StyledAnchor ref={ref} {...props}>
          <div style={{ padding: '0.25rem 1rem' }}>{children}</div>
        </StyledAnchor>
      </DropdownMenu.Item>
    )
  }
)

export const DropdownLink = createLink(DropdownAnchor)
